import React from 'react';
import './GameControls.css';

/**
 * GameControls component for start/end game buttons
 * Handles button state management and action callbacks
 */
const GameControls = ({
  conversationStarted,
  onEndGame
}) => {
  if (!conversationStarted) {
    return null;
  }

  return (
    <div className="game-controls">
      <button
        type="button"
        className="cq-end-game-button"
        onClick={onEndGame}
      >
        End Game
      </button>
    </div>
  );
};

export default GameControls;
